<template>
  <section class="brands">
    <div class="brands-header">
      <aside class="brands-title">
        <h2>Nuestras marcas</h2>
        <p>
          Por unas mejores alternativas de calidad y precios para nuestro
          clientes
        </p>
      </aside>
      <aside class="brands-button">
        <button @click="moreBrands()">Ver marcas</button>
      </aside>
    </div>
    <swiper
      :modules="modules"
      :spaceBetween="20"
      :navigation="true"
      :virtual="true"
      :breakpoints="{
        0: {
          slidesPerView: 1,
        },
        300: {
          slidesPerView: 3,
        },
        380: {
          slidesPerView: 4,
        },
        600: {
          slidesPerView: 5,
        },
        980: {
          slidesPerView: 6,
        },
        1200: {
          slidesPerView: 10,
        },
        1420: {
          slidesPerView: 12,
        },
      }"
      class="mySwiper brand-logos"
    >
      <swiper-slide v-for="brand in brands" :key="brand.nameBrand">
        <div>
          <img :src="brand.img" :alt="brand.nameBrand" />
        </div>
      </swiper-slide>
    </swiper>
  </section>
</template>

<script setup>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "../styles/BrandsHome.stye.scss";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/virtual";

// import required modules
import { Pagination, Navigation, Virtual } from "swiper/modules";
import { ref } from "vue";
import { useRouter } from "vue-router";

// Data
import brands from "@/data/brands.json";

const modules = ref([Pagination, Navigation, Virtual]);
const router = useRouter();

function moreBrands() {
  router.push("/marcas");
}
</script>

<style lang="scss" scoped>
.brands {
  padding-inline: 300px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 100px;
  h2 {
    color: #071725;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: start;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    text-align: start;
    margin: 0;
  }

  .brands-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .brands-title {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    .brands-button {
      button {
        padding: 10px 20px;
        border: 1px solid $tint4;
        background: none;
        color: $tint2;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s ease;

        &:hover {
          background-color: $tint4;
        }
      }
    }
  }

  .brand-logos {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-top: 40px;
    div {
      width: 170px;
      padding: 15px 30px;
      align-items: center;
      border-radius: 5px;
      background: var(--whited, #ffffff);
      box-shadow: 0px 0px 5.3px -3px rgba(34, 115, 184, 0.1);
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}

@media (max-width: 1600px) {
  .brands {
    padding-inline: 100px;
    h2 {
      font-size: 32px;
    }
    .brand-logos {
      div {
        width: 120px;
        padding: 0px;
        padding-inline: 10px;
      }
    }
  }
}
@media (max-width: 1080px) {
  .brands {
    padding-inline: 80px;
    h2 {
      font-size: 24px;
    }
    .brands-header {
      display: flex;
      align-items: start;
      flex-direction: column;
      gap: 20px;
    }
  }
}
@media (max-width: 580px) {
  .brands {
    padding-inline: 20px;
  }
}
</style>
